
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[province]",
      function () {
        return require("private-next-pages/[province]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[province]"])
      });
    }
  